import React, { useEffect, useRef, useState } from 'react';
import { Box, IconButton, Tooltip, useMediaQuery, useTheme, Avatar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ReusableModal from '../MUIComponent/Utlis/Modal/Modal';
import AddNewChildForm from './AddNewChildForm';
import StaffSuccessModal from '../MUIComponent/Utlis/Modal/StaffSuccessModal';
import { useAuth } from '../../hooks/useAuth';
import configAPI from '../../api/config';
import { StudentVisitByParent, ParentAddKidID, VarifyOTPParentAddKidID } from '../../api/StudentService/StudentServide';
import { useSnackbar } from '../MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import { useNavigate } from 'react-router-dom';
import { loginKidSuccess } from '../../features/auth/kidAuthSlice';
import { loginSuccess } from '../../features/auth/authSlice';
import { useParentKidAuth } from '../../hooks/parentKidUseAuth';
import { myDashboard, Roles } from '../../constants/params/constants';



// const DummyChildrenList = [
//     { id: 1, name: "Aarav Sharma", photo: "/assets/images/teacherdash/boy1.jpg" },
// ];


const AllChildrenDropdown = () => {
    const { user } = useAuth();
    const { parentkidUser } = useParentKidAuth();
    const schoolID = user ? user.schoolID: null;
    const { showSnackbar } = useSnackbar();
    const rawChildrenList = user?.parentStudentList || parentkidUser?.parentStudentList  || [];
    const [isLoading, setIsLoading] = useState(false);
const [isInitialLoad, setIsInitialLoad] = useState(true);
    const getProfileImageURL = (student) => {
    let profileImage = student.profileImage;
    let ImageUrl = `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}/`;

    // Step 1: If null, parse documents
    if (!profileImage && student.documents) {
        try {
            const docs = JSON.parse(student.documents);
            const profileDoc = docs.find(
                doc => doc.DocumentName === "Profile Image"
            );
            if (profileDoc) {
                profileImage = profileDoc.DocumentImage;
            }
        } catch (err) {
            return null;
        }
    }

    // Step 2: Full URL
    const ProfileImageURL = profileImage
        ? `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}${profileImage.startsWith('/') ? '' : '/'}${profileImage}`
        : null;

    return ProfileImageURL;
};


const childrenList = rawChildrenList.map(item => ({
    studentID: item.studentID,
    name: item.studentName,
    photo: getProfileImageURL(item),
    schoolName: item.schoolName,
    parentID: item.parentID
}));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const isBelow425 = useMediaQuery('(max-width:425px)');
    const customColors = useSelector((state) => state.theme.customColors);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
   const currentUser = useSelector((state) => state.auth.user);
   
    const [isOpen, setIsOpen] = useState(false);
    const [openAddPopup, setOpenAddPopup] = useState(false);

    const [successOpen, setSuccessOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [childList, setChildList] = useState(childrenList);
    const [selectedChild, setSelectedChild] = useState(() => {
        if (currentUser?.studentID && childrenList.length > 0) {
            const foundChild = childrenList.find(child => 
                child.studentID === currentUser.studentID
            );
            if (foundChild) return foundChild;
        }
        return null;
    });

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

     useEffect(() => {
        if (childrenList.length > 0) {
            if (currentUser?.studentID) {
                const foundChild = childrenList.find(child => 
                    child.studentID === currentUser.studentID
                );
                
                if (foundChild) {
                    if (!selectedChild || selectedChild.studentID !== foundChild.studentID) {
                        setSelectedChild(foundChild);
                    }
                } else if (!selectedChild) {
                    setSelectedChild(childrenList[0]);
                    handleSelect(childrenList[0]);
                }
            } else if (!selectedChild) {
                setSelectedChild(childrenList[0]);
                handleSelect(childrenList[0]);
            }
        }
    }, [childrenList, currentUser]);


    const handleSelect = async (child) => {
        setSelectedChild(child);
        setIsOpen(false);

        if (!schoolID) return;
        try {
            setIsLoading(true);

            const payloadVisit = {
                ParentID:
                    (parentkidUser?.roleName === Roles[3].RoleName && parentkidUser?.parentID) ||
                    (user?.roleName === Roles[3].RoleName && user?.parentID),
                StudentID: child.studentID
            }
            const res = await StudentVisitByParent(payloadVisit);
            if (res?.success) {
             const responseData = res;
                const documents = JSON.parse(responseData?.data?.documents || '[]');
                const profileDoc = documents.find(doc => doc.DocumentName === "Profile Image");
                const ProfileUrl = profileDoc?.DocumentImage || '';
        
                const payload = {
                    classID: responseData?.data?.studentClassDetails?.[0]?.classID,
                    sectionID: responseData?.data?.studentClassDetails?.[0]?.sectionID,
                    studentID: responseData?.data?.studentID,
                    employeeID: responseData?.data?.employeeID,
                    adminID: responseData?.data?.adminID,
                    firstName: responseData?.data?.firstName,
                    fullName: responseData?.data?.fullName,
                    lastName: responseData?.data?.lastName,
                    email: responseData?.data?.email,
                    phoneNumber: responseData?.data?.phoneNumber,
                    roleID: responseData?.data?.roleID,
                    roleName: responseData?.data?.roleName,
                    routes: responseData?.data?.routes,
                    schoolID: responseData?.data?.schoolID,
                    schoolName: responseData?.data?.schoolName,
                    isParentVisitStudentDash: responseData?.data?.isParentVisitStudentDash,
                    ProfileUrl: responseData?.data?.profileImage || ProfileUrl,
                    registrationNumber: responseData?.data?.registrationNumber,
                    className: responseData?.data?.studentClassDetails?.[0]?.className,
                    sectionName: responseData?.data?.studentClassDetails?.[0]?.sectionName,
                    streamName: responseData?.data?.studentClassDetails?.[0]?.streamName,
                      subStreamName: responseData?.data?.studentClassDetails?.[0]?.subStreamName,
                    parentStudentList:responseData?.data?.parentStudentList
                };
                
                var CloneUser = null;
                if(user?.studentID == null){
                     CloneUser = user;
                }

                dispatch(loginSuccess(payload));
                if(CloneUser != null){
                    dispatch(loginKidSuccess(CloneUser));
                }
        }
        } catch (error) {
            showSnackbar('Failed to load classes', error);
        } finally {
            setIsLoading(false);
        }
    };

    




    const handleAddNewClick = async () => {
        setIsOpen(false);
        setOpenAddPopup(true);
    };

    //  const handleMyDashboard = async () => {
    //     const CloneParentkidUser = parentkidUser;
    //     const CloneUser = user;

    //     let FirstOne = null;
    //     let SecondOne = null;

    //     if (CloneParentkidUser?.parentID) {
    //         FirstOne = CloneParentkidUser;
    //         SecondOne = CloneUser;
    //     } else if (CloneUser?.parentID) {
    //         FirstOne = CloneUser;
    //         SecondOne = CloneParentkidUser;
    //     }

    //     if (FirstOne) {
    //         dispatch(loginSuccess(FirstOne));
    //     }
    //     dispatch(loginKidSuccess(SecondOne));
    // };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (successOpen) {
            const timer = setTimeout(() => {
                setSuccessOpen(false);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [successOpen]);


    return (
        <>
            <Box ref={dropdownRef} className="year-dropdown">

                <Tooltip title="Select Child">
                    <Box
                        className="year-dropdown-header"
                        onClick={toggleDropdown}
                        sx={{
                            p: "0!important",
                            color: theme.palette.background.text,
                            backgroundColor: isOpen ? theme.palette.custom?.listMenuhoverbg : 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            cursor: "pointer"
                        }}
                    >
                        <Avatar
                            src={selectedChild?.photo || ""}
                            variant="square"
                            sx={{ width: 28, height: 28, borderRadius: "4px" }}
                        />

                        {!isBelow425 && (
                            <span style={{ fontSize: "14px", fontWeight: 500 }}>
                                {selectedChild?.name || "Select Child"}
                            </span>
                        )}

                    </Box>
                </Tooltip>

                {/* DROPDOWN LIST */}
                {isOpen && (
                    <Box
                        component="ul"
                        className="year-dropdown-list"
                        sx={{
                            width: '200px!important',
                            backgroundColor: theme.palette.background.bgwhite,
                            maxHeight: 220,
                            overflowY: 'auto',
                            borderRadius: "6px",
                            boxShadow: theme.shadows[4],
                            p: "4px 0",
                        }}
                    >
                        {/* <Box
                                component="li"
                                onClick={() => handleMyDashboard()}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px 16px!important',
                                    color: theme.palette.background.text,
                                    cursor: 'pointer',
                                    gap: 1,
                                    '&:hover': { backgroundColor: theme.palette.custom?.listMenuhoverbg || '#f0f0f0' },
                                }}
                            >
                                <Avatar
                                    src={`${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}${parentkidUser?.roleName === Roles[3].RoleName && parentkidUser?.ProfileUrl  || user?.roleName === Roles[3].RoleName && user?.ProfileUrl}`}
                                    variant="square"
                                    sx={{ width: 28, height: 28, borderRadius: "4px" }}
                                />
                                <span>{myDashboard}</span>
                            </Box> */}
                        {childList
                            ?.filter(child => child && child.studentID)
                            .map((child) => (
                                <Box
                                    component="li"
                                    key={child.studentID}
                                    onClick={() => handleSelect(child)}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '8px 16px!important',
                                        color: theme.palette.background.text,
                                        cursor: 'pointer',
                                        gap: 1,
                                        '&:hover': { backgroundColor: theme.palette.custom?.listMenuhoverbg || '#f0f0f0' },
                                    }}
                                >
                                    <Avatar
                                        src={child.photo || ""}
                                        variant="square"
                                        sx={{ width: 28, height: 28, borderRadius: "4px" }}
                                    />
                                    <span>{child.name}</span>
                                </Box>
                            ))}


                        {/* ADD NEW CHILD */}
                        {/* {parentkidUser?.roleName === Roles[3].RoleName  && 
                          <Box
                            component="li"
                            onClick={handleAddNewClick}
                            sx={{
                                padding: '8px 16px!important',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                '&:hover': { backgroundColor: theme.palette.custom?.listMenuhoverbg },
                            }}
                        >
                            <IconButton
                                sx={{
                                    color: customColors?.activeButton || theme.palette.background.bgpurple,
                                    border: `1px solid ${theme.palette.divider}`,
                                    borderRadius: "100%",
                                    width: "32px",
                                    height: "32px"
                                }}
                            >
                                <i className="fa-regular fa-circle-plus" style={{ fontSize: "16px" }}></i>
                            </IconButton>

                            <span style={{ fontWeight: 600, color: theme.palette.custom.greytextColor }}>
                                Add New Child
                            </span>
                        </Box>
                        }

                        {user?.roleName === Roles[3].RoleName && 
                          <Box
                            component="li"
                            onClick={handleAddNewClick}
                            sx={{
                                padding: '8px 16px!important',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                '&:hover': { backgroundColor: theme.palette.custom?.listMenuhoverbg },
                            }}
                        >
                            <IconButton
                                sx={{
                                    color: customColors?.activeButton || theme.palette.background.bgpurple,
                                    border: `1px solid ${theme.palette.divider}`,
                                    borderRadius: "100%",
                                    width: "32px",
                                    height: "32px"
                                }}
                            >
                                <i className="fa-regular fa-circle-plus" style={{ fontSize: "16px" }}></i>
                            </IconButton>

                            <span style={{ fontWeight: 600, color: theme.palette.custom.greytextColor }}>
                                Add New Child
                            </span>
                        </Box>
                        }
                       */}
                    </Box>
                )}
            </Box>

            {/* ADD CHILD POPUP */}
            <ReusableModal
                open={openAddPopup}
                onClose={() => setOpenAddPopup(false)}
                title="Add New Child"
                // style={{
                //     width: isMobile ? '90%' : isTablet ? '50%' : '30%',
                // }}
            >
                <AddNewChildForm
                    onSuccess={(newChild) => {
                        setChildList((prev) => [...prev, newChild]);
                        // setSelectedChild(newChild);
                        setOpenAddPopup(false);
                        setSuccessOpen(true);
                    }}
                />
            </ReusableModal>

            <StaffSuccessModal
                open={successOpen}
                onClose={() => setSuccessOpen(false)}
                message="Child Added Successfully!"
                headerBg="transparent"
                showCloseIcon={false}
                // style={{
                //     width: isBelow425 ? "95%" : isMobile ? '90%' : isTablet ? '50%' : '40%',
                //     maxHeight: isBelow425 ? "78vh" : "90vh",
                //     overflowY: "auto"
                // }}
            />
        </>
    );
};

export default AllChildrenDropdown;
